import type { DataGridProps } from '@mui/x-data-grid'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Zustand store for DataGrid preferences that shouldn't be in URL.
 * Column visibility is a UI preference, not a data query.
 */
interface GridStore {
  columnVisibilityModel: DataGridProps['columnVisibilityModel']
  setColumnVisibilityModel: (columnVisibilityModel: DataGridProps['columnVisibilityModel']) => void
}

export const useGridStore = create<GridStore>()(
  persist(
    (set): GridStore => ({
      columnVisibilityModel: {
        hash: false,
        address_line_3: false,
        address_line_4: false
      },
      setColumnVisibilityModel: (columnVisibilityModel: DataGridProps['columnVisibilityModel']) =>
        set({ columnVisibilityModel })
    }),
    {
      name: 'grid-store'
    }
  )
)
